import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Font } from '../styles/constants';
import FormField, { Field } from './FormField';
import { CheckBox, CheckBoxItem } from './CheckBox';
import Hr from './Hr';
import Label from './Label';
import TextArea from './TextArea';

const StyledFormField = styled(FormField)`
  font-family: ${Font.default};

  * {
    font-family: ${Font.default};
  }
`;

const StyledTextArea = styled(TextArea)`
  margin-top: 8px;
`;

class SurveyForm extends Component {
  render() {
    const {
      config,
      onActionClick,
      onCloseClick,
      onCheckBoxChange,
      selectedValues,
      textAreaValue,
      onTextAreaChange,
      ...rest
    } = this.props;

    return (
      <StyledFormField
        title={config.inquiry.title}
        message={config.inquiry.question}
        onActionClick={onActionClick}
        onCloseClick={onCloseClick}
        actionLabel={config.inquiry.sendBtnTxt}
        {...rest}
      >
        <CheckBox selectedValues={selectedValues} onChange={onCheckBoxChange}>
          {config.inquiry.options.map((opt, i) => (
            <Field key={`${opt.value}-${i}`}>
              <CheckBoxItem value={opt.value} label={opt.label} />
            </Field>
          ))}
        </CheckBox>
        {config.inquiry.freeInput.available && (
          <Field>
            <Hr />
            <Label
              isActive={textAreaValue !== undefined && textAreaValue.length > 0}
            >
              {config.inquiry.freeInput.title}
            </Label>
            <StyledTextArea value={textAreaValue} onChange={onTextAreaChange} />
          </Field>
        )}
      </StyledFormField>
    );
  }
}

SurveyForm.propTypes = {
  config: PropTypes.shape({
    triggerIdName: PropTypes.string,
    expirationPeriod: PropTypes.number,
    toast: PropTypes.shape({
      inquiryTxt: PropTypes.string,
      yesBtnTxt: PropTypes.string,
      noBtnTxt: PropTypes.string,
      thanksTxt0: PropTypes.string,
      thanksTxt1: PropTypes.string,
    }),
    inquiry: PropTypes.shape({
      title: PropTypes.string,
      question: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          label: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      freeInput: PropTypes.shape({
        available: PropTypes.bool,
        name: PropTypes.string,
        title: PropTypes.string,
      }),
      sendBtnTxt: PropTypes.string,
    }),
  }).isRequired,
  onActionClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onCheckBoxChange: PropTypes.func,
  selectedValues: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ),
  textAreaValue: PropTypes.string,
  onTextAreaChange: PropTypes.func,
};

SurveyForm.defaultProps = {
  onActionClick: () => {},
  onCloseClick: () => {},
  onCheckBoxChange: () => {},
  selectedValues: [],
  textAreaValue: undefined,
  onTextAreaChange: () => {},
};

export default SurveyForm;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/SurveyForm.jsx